import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=3b9fe420&scoped=true&"
import script from "./IconSvg.vue?vue&type=script&lang=ts&"
export * from "./IconSvg.vue?vue&type=script&lang=ts&"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=3b9fe420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fe420",
  null
  
)

export default component.exports